import { logger } from '../logger';
export var deprecate = function deprecate(msg, scope) {
  var warn = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : logger.warn;
  var warned = false;

  var deprecateOnce = function deprecateOnce() {
    if (process.env.NODE_ENV !== 'production' && !warned) {
      warn(msg, scope);
      warned = true;
    }
  };

  return deprecateOnce;
};